export const WORK_MONTH_SUMMARY_MANAGE = (person_id, year, month) =>
  `/work_month_summary/${person_id}/${year}/${month}/manage`;

export const WORK_MONTH_SUMMARY = (year, month) =>
  `/work_month_summary/${year}/${month}/`;

export const WORK_MONTH_SUMMARY_GENERIC = (year, month) =>
  `/work_month_summary/${year}/${month}/generic`;
